import { motion } from "framer-motion";
import { Fuel, Sun, Battery, TrendingUp, ShieldCheck } from "lucide-react";
import { CUSTOMER_BENEFITS, IMAGES } from "@/data/content";

const BENEFIT_ICONS = [Fuel, Sun, Battery, TrendingUp, ShieldCheck];

const BenefitRow = ({ item, index }) => {
  const Icon = BENEFIT_ICONS[index];
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.4 }}
      transition={{ duration: 0.5, delay: index * 0.07 }}
      data-testid={`customer-benefit-item-${index}`}
      className={`flex gap-4 py-6 ${index !== 0 ? "border-t border-borderLight" : ""}`}
    >
      <span aria-hidden="true" className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-teal/15 bg-glacier text-teal">
        <Icon size={16} strokeWidth={1.6} />
      </span>
      <div>
        <h3 className="font-heading text-xs font-semibold tracking-[0.12em] text-ink uppercase">{item.title}</h3>
        <p className="text-inkSoft leading-relaxed mt-2 text-[15px]">
          {item.title === "Improve Energy Resilience" ? (
            <>
              Maintain a local energy reserve when grid power is limited
              <br className="hidden lg:block" /> or unavailable.
            </>
          ) : (
            item.body
          )}
        </p>
      </div>
    </motion.div>
  );
};

export const CustomerBenefits = () => (
  <section data-testid="customer-benefits-section" className="bg-surfaceLight px-6 py-[30px] sm:py-[40px] lg:px-12 lg:py-[70px]">
    <div className="lg:max-w-[1280px] lg:mx-auto">
      <div className="grid grid-cols-1 gap-[30px] sm:gap-10 lg:grid-cols-[45fr_55fr] lg:gap-16 items-start">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="font-heading text-[30px] sm:text-[35px] lg:text-[41px] font-semibold text-ink leading-tight">
            What your farm gains
          </h2>
          <p className="text-[15px] text-inkSoft leading-relaxed mt-6 max-w-md lg:max-w-none lg:tracking-tight">
            The value of a hybrid microgrid is not the technology itself — it is what that
            technology allows the operation to keep doing.
          </p>

          <div className="mt-8 h-[280px] overflow-hidden rounded-3xl sm:h-[340px] lg:mt-10 lg:h-[374px] lg:-ml-[27px] lg:-mr-[27px]">
            <img
              src={IMAGES.benefitsInfrastructure}
              alt="High-voltage transmission lines and wind turbines across a British Columbia agricultural field"
              className="h-full w-full object-cover"
            />
          </div>
        </motion.div>

        <div className="lg:pl-[65px]">
          <div className="border-t border-borderLight" />
          {CUSTOMER_BENEFITS.map((item, i) => (
            <BenefitRow key={item.title} item={item} index={i} />
          ))}
        </div>
      </div>
    </div>
  </section>
);

